<template>
  <div>
    <Form ref="form" :rules="formRules" :model="formData" :label-width="150" :inline="true">
      <FormItem label="项目名称" prop="projectName">
        <Input :disabled="alreadyDone" v-model="formData.projectName" class="input-long"/>
      </FormItem>
      <FormItem label="所属城市" prop="projectCityCode">
        <Select :disabled="alreadyDone" class="select-width"
                v-model="formData.projectCityCode"
                :filterable="true"
                @on-change="cityChange"
        >
          <Option value="">请选择</Option>
          <Option v-for="item in cityList" :value="item.code" :key="'keyX'+item.code">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem label="所属区域" prop="projectRegionCode">
        <Select :disabled="alreadyDone" class="select-width" v-model="formData.projectRegionCode">
          <Option value="" v-if="!formData.projectCityCode">请先选择城市</Option>
          <Option v-if="regionList.length>0" value="">请选择</Option>
          <Option v-for="item in regionList" :value="item.code" :key="'keyZ'+item.code">{{item.text}}</Option>
        </Select>
      </FormItem>
      <br>
      <FormItem label="项目地址" prop="projectAddress" class="ivu-form-item-required">
        <input :disabled="alreadyDone" id="suggestIdbase" @blur="validAddress" v-model="formData.projectAddress"
               :class="['input-long', 'ivu-input',{'redline':formData.addressValid}]"/>
        <div id="searchResultPanel" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
      </FormItem>

      <FormItem label="经度" prop="projectLon">
        <Input disabled class="input-short" v-model="formData.projectLon"/>
      </FormItem>

      <FormItem label="纬度" prop="projectLat">
        <Input disabled class="input-short" v-model="formData.projectLat"/>
      </FormItem>
      <br>
      <div id="map-container" class="map-container ">
      </div>

      <FormItem label="楼栋数" prop="projectBuildingNum">
        <Input :disabled="alreadyDone" class="input-short" v-model="formData.projectBuildingNum"/>
      </FormItem>

      <FormItem label="空置天数" prop="projectVacancyDay">
        <Input :disabled="alreadyDone" class="input-short" v-model="formData.projectVacancyDay"/>
      </FormItem>
      <FormItem label="项目面积(㎡)" prop="projectArea">
        <Input :disabled="alreadyDone" class="input-short" v-model="formData.projectArea"></Input>
      </FormItem>
      <FormItem label="公区面积(㎡)" prop="projectPublicArea">
        <Input :disabled="alreadyDone" class="input-short" v-model="formData.projectPublicArea"/>
      </FormItem>
      <br>
      <FormItem label="用水类别" prop="projectWaterType">
        <!--<Input :disabled="alreadyDone" class="input-short" v-model="formData.projectWaterType"/>-->
        <Select :disabled="alreadyDone" class="select-width" v-model="formData.projectWaterType">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in projectWaterType" :value="item.value" :key="'keyMM'+index">{{item.text}}
          </Option>
        </Select>
      </FormItem>
      <FormItem label="水基价(元/吨)" prop="projectWaterPrice">
        <Input :disabled="alreadyDone" class="input-short" v-model="formData.projectWaterPrice"/>
      </FormItem>

      <FormItem label="用电类别" prop="projectPowerType">
        <!--<Input :disabled="alreadyDone" class="input-short" v-model="formData.projectPowerType"/>-->
        <Select :disabled="alreadyDone" class="select-width" v-model="formData.projectPowerType">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in projectPowerType" :value="item.value" :key="'keyNN'+index">{{item.text}}
          </Option>
        </Select>
      </FormItem>
      <FormItem label="电基价(元/度)" prop="projectPowerPrice">
        <Input :disabled="alreadyDone" class="input-short" v-model="formData.projectPowerPrice"/>
      </FormItem>
      <br>
      <FormItem label="供暖方式" prop="heatingMode">
        <Select :disabled="alreadyDone" class="select-width" v-model="formData.heatingMode">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in projectHeatingModel" :value="item.value" :key="'keyD'+index">{{item.text}}
          </Option>
        </Select>
      </FormItem>

      <FormItem label="车位数" prop="projectCarPortNum">
        <Input :disabled="alreadyDone" class="input-short" v-model="formData.projectCarPortNum"/>
      </FormItem>

      <FormItem label="合作模式" prop="projectCooperationModel">
        <Select :disabled="alreadyDone" class="select-width" v-model="formData.projectCooperationModel">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in modeList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
        </Select>
      </FormItem>
      <FormItem label="开业日期" prop="projectOpeningTime">
        <DatePicker :disabled="alreadyDone" type="date" placeholder="选择开业日期"
                    v-model="formData.projectOpeningTime"></DatePicker>
      </FormItem>
      <FormItem label="最新装修日期" prop="projectDecorateTime">
        <DatePicker :disabled="alreadyDone" type="date" placeholder="选择装修日期"
                    v-model="formData.projectDecorateTime"></DatePicker>
      </FormItem>
      <FormItem label="资金结算平台" prop="receiptType">
        <Select :disabled="alreadyDone" class="select-width" v-model="formData.receiptType">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in projectReceipt" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
        </Select>
      </FormItem>
      <br>
      <FormItem label="业主名称" prop="ownerId">
        <Select :disabled="alreadyDone" class="select-long2" v-model="formData.ownerId">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in projectOwner" :value="item.fid" :key="'keyE'+index">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem label="结算公司名称" prop="projectCompanyCode">
        <Select :disabled="alreadyDone" class="select-long2" v-model="formData.projectCompanyCode">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in projectCompany" :value="item.code" :key="'keyC'+index">{{item.name}}</Option>
        </Select>
      </FormItem>
      <br>

      <FormItem label="起租-到期时间" :label-width="150" prop="dateList">
        <DatePicker :disabled="alreadyDone" v-model="formData.dateList" class="select-long2" type="daterange"
                    placement="bottom-end"
                    placeholder="选择起租、到期时间" @on-change="changeDateList"></DatePicker>
      </FormItem>
      <FormItem label="租赁时长(天)" prop="projectContractCycle">
        <Input disabled class="input-short" v-model="formData.projectContractCycle"/>
      </FormItem>

      <FormItem label="收房合同号" prop="receivedContract">
        <Input :disabled="alreadyDone" class="input-short" v-model="formData.receivedContract"/>
      </FormItem>
      <br>
      <FormItem label="项目描述" prop="projectDescription">
        <Input type="textarea" :disabled="alreadyDone" :rows="4" class="input-long300"
               v-model="formData.projectDescription"/>
      </FormItem>
      <br>
      <FormItem label="项目说明">
        <Input :disabled="alreadyDone" class="input-long300" v-model="formData.projectIntro"/>
      </FormItem>
      <br>
      <FormItem label="备注" prop="remark">
        <Input :disabled="alreadyDone" class="input-long300" v-model="formData.remark"/>
      </FormItem>
      <br>
      <FormItem label="商机电话" prop="numberType">
        <Select :disabled="alreadyDone" class="select-width" v-model="formData.numberType">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in numberTypes" :value="item.value" :key="'keyMM'+index">{{item.text}}
          </Option>
        </Select>
      </FormItem>
    </Form>
  </div>
</template>
<script>
  import {projectregion} from "../../../../api/project";
  import {deepClone} from "../../../../utils/format";

  export default {
    name: 'baseinfo',
    props: {
      conditionList: {
        type: Object,
        default: {}
      },
      formData: {
        type: Object,
        default: null,
      },
      alreadyDone: {
        type: Boolean,
        default: false
      },
      regionListOri: {
        type: Array,
        default: []
      },
      isAdd: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      regionListOri: {
        handler: function (val) {
          this.regionList = deepClone(val)
        },
        deep: true
      },
    },
    data() {
      return {
        regionList: deepClone(this.regionListOri),
        addressValid: false,
        formRules: {
          projectName: [
            {required: true, message: ' ', trigger: 'blur', type: 'string'}
          ],
          projectCityCode: [
            {required: true, trigger: 'change', message: ' ', type: 'string'}
          ],
          projectRegionCode: [
            {required: true, trigger: 'change', message: '请选择区域', type: 'string'}
          ],
          // projectAddress: [
          //   {required: true, message: ' ', trigger: 'blur', type: 'string'}
          // ],
          projectVacancyDay: [
            {required: true, message: '请输入正确数字', trigger: 'blur', validator: this.validateNumber}

          ],  //空置天数
          // projectContractBegin: [],
          // projectContractEnd: [],
          projectContractCycle: [
            {required: true, message: '请输入正确数字', trigger: 'change', validator: this.validateNumber}
          ], //租赁年限
          // projectLon: [],//经度
          // projectLat: [],//纬度
          projectArea: [
            {required: true, message: '请输入正确数字', trigger: 'blur', validator: this.validateNumber}
          ],//项目面积
          projectPublicArea: [
            {required: true, message: '请输入正确数字', trigger: 'blur', validator: this.validateNumber}
          ],//公区面积
          projectBuildingNum: [
            {required: true, message: '请输入正确数字', trigger: 'blur', validator: this.validateNumber}
          ],
          projectDescription: [
            {required: true, message: ' ', trigger: 'blur', type: 'string'}
          ],
          // projectState:[],
          projectCooperationModel: [
            {required: true, trigger: 'change', message: ' ', validator: this.validateNumber}
          ], //合作模式
          projectCompanyCode: [
            {required: true, trigger: 'change', message: ' ', type: 'string'}
          ],
          receiptType: [
            {required: true, trigger: 'change', message: ' ', type: 'number'}
          ],
          //结算公司编码
          // projectCompanyName: [],//结算公司名称
          projectCarPortNum: [
            {required: true, trigger: 'blur', message: ' ', validator: this.validateNumber}
          ],
          projectWaterType: [
            {required: true, message: ' ', trigger: 'change', validator: this.validateNumber}
          ],
          projectWaterPrice: [
            {required: true, message: '请输入正确数字', trigger: 'blur', validator: this.validateNumber2}
          ],
          projectPowerType: [
            {required: true, message: ' ', trigger: 'change', validator: this.validateNumber}
          ],
          projectPowerPrice: [
            {required: true, message: '请输入正确数字', trigger: 'blur', validator: this.validateNumber2}
          ],
          projectOpeningTime: [
            {required: true, message: ' ', trigger: 'change', type: 'date'}
          ],
          projectDecorateTime: [
            {required: true, message: ' ', trigger: 'change', type: 'date'}
          ],
          ownerId: [
            {required: true, message: ' ', trigger: 'change', type: 'string'}
          ],
          projectIntro: [
            {required: true, message: ' ', trigger: 'blur', type: 'string'}
          ],
          remark: [
            {required: false, message: '', trigger: 'blur', type: 'string'}
          ],
          heatingMode: [
            {required: true, trigger: 'change', message: ' ', validator: this.validateNumber}
          ],
          dateList: [
            {required: true, trigger: 'change', message: ' ', validator: this.validateDate}
          ],
          receivedContract: [
            {required: true, message: ' ', trigger: 'blur', type: 'string'}
          ],
          // 线路
          numberType: [
            {required: true, trigger: 'change', message: ' ', validator: this.validateNumber}
          ]
          // houseTypeNum:'',   //房型数
          // houseNum:'',  //房间数
        },
        isSet: false

      }
    },
    computed: {
      projectPowerType() {
        return this.conditionList.projectPowerType || []
      },
      projectWaterType() {
        return this.conditionList.projectWaterType || []
      },
      cityList() {
        return this.conditionList.city || []
      },
      modeList() {
        return this.conditionList.projectType || []
      },
      projectReceipt(){
         return this.conditionList.projectReceipt || []
      },
      projectCompany() {
        return this.conditionList.projectCompany || []
      },
      projectHeatingModel() {
        return this.conditionList.projectHeatingModel || []
      },
      projectOwner() {
        return this.conditionList.projectOwner || []
      },
      projectCompanyMap() {
        var ret = {}
        this.projectCompany.forEach(ele => {
          ret[ele.code + ''] = ele.name
        })
        return ret
      },
      numberTypes() {
        return this.conditionList.numberType || []
      }
    },
    methods: {

      validateDate(rule, value, callback) {
        if (!value[0] || !value[1]) {
          callback(new Error('请选择日期'));
        }
        callback();
      },
      cityChange(value) {
        if (this.formData.projectCityCode){
          this.formData.projectCityName = this.cityList.find(item => {
              return item.code === this.formData.projectCityCode;
          }).name;
        } else {
          this.formData.projectCityName = '';
        }
        console.log( this.formData.projectCityName);
        this.getRegion()
      },
      getRegion() {
        if (!this.formData.projectCityCode) {
          this.regionList = []
          return
        }
        var params = {
          cityCode: this.formData.projectCityCode
        }
        projectregion(params).then(res => {
          this.regionList = res.data.region
        })

      },
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },

      validateNumber2(rule, value, callback) {
        let pattern = /^(\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      changeDateList(value) {

        if (!value[0] || !value[1]) {
          this.formData.projectContractCycle = ''
          return
        }
        var t = Date.parse(value[1]) - Date.parse(value[0])
        this.formData.projectContractCycle = parseInt(t / 1000 / 60 / 60 / 24) + 1

      },
      validAddress() {
        if (!this.formData.projectAddress) {
          this.formData.addressValid = true
        }
        else {
          this.formData.addressValid = false
        }
      }
    },
    mounted() {
      setPoint(this.formData)
    },
  }


  function setPoint(formData) {

    var map = new BMap.Map("map-container");
    var searchValue
    var pointObject = {
      text: '',
      city: '',
      district: '',
      defaultPoint: [],
      customPoint: []
    }

    map.disableScrollWheelZoom();

    if (formData.projectLon && formData.projectLat) {
      var point1 = new BMap.Point(formData.projectLon, formData.projectLat)

      map.centerAndZoom(point1, 14);
      map.addOverlay(new BMap.Marker(point1));
    }
    else {
      map.centerAndZoom('北京', 12);

    }
    //建立一个自动完成的对象
    var ac = new BMap.Autocomplete(
      {
        "input": "suggestIdbase",
        "location": map
      });
    if (formData.projectAddress) {
      ac.setInputValue(formData.projectAddress)
    }

    ac.addEventListener("onconfirm", function (e) {
      var _value = e.item.value;
      searchValue = _value.province + _value.city + _value.district + _value.business;
      pointObject.text = _value.business;
      pointObject.city = _value.city;
      pointObject.district = _value.district;
      ac.setInputValue(_value.business)
      formData.projectAddress = _value.business
      setPlace();
    });

    ac.addEventListener("onhighlight", function (e) {  //鼠标放在下拉列表上的事件
      if (e.toitem.index > -1) {
        ac.setInputValue(e.toitem.value.business)
        // formData.projectAddress = e.toitem.value.business
      }
    });

    function setPlace() {
      map.clearOverlays();    //清除地图上所有覆盖物
      var local = new BMap.LocalSearch(map, { //智能搜索
        onSearchComplete: myFun
      });
      local.search(searchValue);

      function myFun() {
        if (local.getResults().Br && local.getResults().Br.length === 0) {
          formData.addressValid = true
          formData.projectLon = ''
          formData.projectLat = ''
          return
        }
        formData.addressValid = false
        var pp = local.getResults().getPoi(0).point;
        pointObject.defaultPoint[0] = pp.lng
        pointObject.defaultPoint[1] = pp.lat
        formData.projectLon = pp.lng
        formData.projectLat = pp.lat
        var marker = new BMap.Marker(pp)  //{enableDragging: false}
        map.centerAndZoom(pp, 18);
        map.addOverlay(marker);
      }
    }

    // return map
  }
</script>

<style scoped>

  .time-width {
    width: 250px;
  }

  .redline {
    border: 1px solid red;
  }

  .map-container {
    width: 50%;
    height: 180px;
    margin-bottom: 16px;
    margin-left: 150px;
  }

  .input-long300 {
    width: 500px;
  }

  .input-long {
    width: 200px;
  }

  .select-long2 {
    width: 300px;
  }

  .select-long {
    width: 200px;
  }

  .select-width {
    width: 100px;
  }

  .select-width2 {
    width: 150px;
  }

  .input-short {
    width: 100px;
  }

</style>
